<template>
    <div class="product container pb-3" id="product" >
        <!-- <span class="closebtn" @click="$router.go(-1)">&times;</span> -->
        <!-- <div class="actionbuttons  d-block d-md-none"> -->
        <!-- <div class="actionbuttons">
            <span class="backbuttons"  @click="isBack()">
                <img class="back-image" src="@/assets/back_arrow.png">
            </span>
            <span class="product addbutton">
                <a  class="addwatchlist text-right" v-on:click="addProductWatchList($store_sel_product, $store_sel_product_pos)" v-if="!$store_sel_product.selected" > 
                    <span class="text-right">
                        <img class="add-image" src="@/assets/Plus.png">
                    </span>
                </a>
                        
                <a class="removewatchlist text-right"  v-on:click="removeProductWatchList($store_sel_product, $store_sel_product_pos)"    v-if="$store_sel_product.selected"> 
                        <span class="text-right">
                            <img class="add-image" src="@/assets/Cross.png">
                        </span>
                </a>
            </span>      
        </div>  -->
        <!-- <div class="actionbuttons container d-none d-md-block">
            <span class="backbuttons"  @click="isBack()">
                <img class="back-image" src="@/assets/back_arrow.png">
            </span>
            <span class="product addbutton">
                <a  class="addwatchlist text-right" v-on:click="addProductWatchList($store_sel_product, $store_sel_product_pos)" v-if="!$store_sel_product.selected" > 
                    <span class="text-right">
                        <img class="add-image" src="@/assets/Plus.png">
                    </span>
                </a>
                        
                <a class="removewatchlist text-right"  v-on:click="removeProductWatchList($store_sel_product, $store_sel_product_pos)"    v-if="$store_sel_product.selected"> 
                        <span class="text-right">
                            <img class="add-image" src="@/assets/Cross.png">
                        </span>
                </a>
            </span>      
        </div>  -->
        <div ref="content ">
            <section>
                <div class="row border hero-img">
                    <img :src="productDetails.hero_img"  :alt="productDetails.product_name" class=" w-100 h-100">
                </div>
                  <div class="centered">{{productDetails.product_name}} </div>
            </section>
            <section>
                <div class="row border border-bottom-0 border-top-0 p-2">
                    <div class="col" >
                        <div class="row">
                            <div class="col col-md-12 p-0"  v-for="(product, index) in productDetails.images" :key="index">
                                <img v-bind:src="product.product_images_url"  :alt="productDetails.product_name" @click="updateImg(index)" class="w-100 p-2 cursor-pointer"/> 
                            </div>
                        </div>
                    </div> 
                    <div class="col-12 col-md-9 min-w-80 p-0">
                        <img :src="productDetails.images[product_index].product_images_url" class="w-100 p-2">
                    </div>
                </div> 
            </section>
             <section>
                <div class="row">
                    <div class="col-12 col-sm p-0 border">
                        <div class="p-2 border-bottom">
                            <div class="p-2 title">
                                Description
                            </div>
                            <div class="col p-2 content">
                                {{productDetails.product_desc}}
                            </div>
                        </div>
                        <ul class="list-group">
                            <li class="list-group-item  border-bottom ">
                                <span class="title"> Features </span>
                                <ul class="pl-3 pt-4">
                                    <li class="content" v-for="(feature,index) in productDetails.features" :key="index">
                                        {{feature.features_name}}
                                    </li>
                                </ul>
                            </li>
                            <li class="list-group-item title border-bottom ">BRAND : <span>{{productDetails.brand_name}}</span></li>
                            <li class="list-group-item title border-bottom ">PRODUCT : <span>{{productDetails.product_name}} </span></li>
                            <li class="list-group-item title border-bottom ">DESIGNER : <span>{{productDetails.product_designer}}</span></li>
                            <li class="list-group-item title border-bottom ">SIZE  :
                                <span class="col">
                                    <span v-if="!productDetails.multiple_flag"> {{productDetails['dimension_depth']}}[D] * {{productDetails['dimension_height']}} [H] * {{productDetails['dimension_width']}}[w] </span>
                                    <span v-if="productDetails.multiple_flag"> Multiple</span>
                                </span>
                            </li> 
                            
                        </ul>
                        <div class="p-2 pl-4">
                            <div class="row">
                                <div class="col-12 title">
                                    <a :href="productDetails.third_party_url" target="_blank" rel="noopener noreferrer">LINK TO {{productDetails.brand_name}}/{{productDetails.product_name}}</a>
                                </div>
                                 <div class="col-7 title"> 
                                    <a :href="productDetails.pdf_file_url" download>PDF</a>
                                </div>
                                </div>
                               <div class="row pt-1">
                               <div class="col-5 title" v-if="productDetails.threed_file_url">
                                    <a :href="productDetails.threed_file_url" download>3D FILE</a>
                               </div>
                               <div class="col-7 title"  v-if="productDetails.twod_file_url">

                                  <a :href="productDetails.twod_file_url" download>2D FILE</a>
                               </div>
                            </div>
                        </div>
                    </div>
                    <div class="col  border border-left-0">
                        <span class="align-bottom">
                            <div class="col p-2"> 
                                <div class="title">{{productDetails.brand_name}}</div>
                            </div>
                            <div class="col p-2 content">
                                {{productDetails.brand_desc}}
                            </div>
                            <div class="col p-2 text-center">
                                    <img v-bind:src="productDetails.brand_img"  :alt="productDetails.brand_name" class="w-100">
                            </div>
                        </span>
                    </div>
                </div>
            </section>
            <section class="py-4">
                 <div class="row border text-uppercase content align-items-center p-2">
                     <div class="col-12  col-md-12 col-lg-2 text-left text-md-left">
                         <span class=" title"> kworktech </span>
                     </div>
                     <div class="col-12 col-md text-left text-md-center">
                         <span class="p-1 d-block d-lg-inline" >
                            raj.menon@kaizenworktech.com
                         </span>
                         <span class="p-1 ">
                             +919845106710
                         </span>
                     </div>
                     <div class="col-12 col-md text-left text-md-center">
                        <span class="p-1 d-block d-lg-inline" >
                            george.browny@kaizenworktech.com
                        </span>
                        <span class="p-1 " >
                             +919845000173
                        </span>
                     </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script lang="ts">
    import Vue from 'vue'
    import jspdf from 'jspdf'
    import html2canvas from "html2canvas"
    import {globalMixin} from '../../mixin.js'

    import * as commonConstant from '../../shared/common.service'
    import ProductService from '../../shared/services/product.service' 
    
    const productService = new ProductService()

    export default Vue.extend ({  
        
        mixins: [globalMixin],
        name: 'product',
        data() {
            return {
                productDetails :{},
                product_index:0, 
                baseURL: commonConstant.baseURL,
                itemDetails : {
                    name:'dummy'
                } 
            }
        },
      

        methods: {
            updateImg(index) {
                this.product_index = index;
            },
             isBack(){
                this.$router.push({path:'/'})
            },
            
            download(){
                const doc = new jspdf()
                var canvasElement = document.createElement('canvas');
                html2canvas(this.$refs.content, { canvas: canvasElement }).then(function (canvas) {
                    const img = canvas.toDataURL("/../../assets/logo.png", 0.8);
                    doc.addImage(img,'png',20,20);
                    doc.save("sample.pdf");
                });
            }
        },
        created() {
            
    // this.logMsg();
    // this.setStatus(2);
    // this.logMsg();
            console.log("product view");
                
    
            const product_id = Number(this.$route.params.product_id) 
            productService.getProductDetails(product_id)
            .then(response => {
                this.productDetails = response.data.output.success[0].data;
            })
            .catch(e => {
                this.errors.push(e);
            })
        },   
    })
</script>

<style  scoped>
  @import '../../style.css';


   .header-bg-image{
       height: 400px !important;
   }
    .list-group-item:first-child {
        border-top-left-radius: .0rem !important; 
        border-top-right-radius: .0rem !important;
    }
    .content{
        font-weight: 400 !important;
    }
    .item-description{
        text-transform: inherit;
        font-family: 'Barlow', sans-serif;
        font-size: 24px;
        color:#858585;
        font-weight: 400;
        padding: 0px;
        float: right;
        width: 65%;
    }

    .list-group-item {
        border:0px;
    }
    .footer-body{
        font-size: 12px;
    }
    .footer-email{
        display: flex;
        padding-right: 0px !important;
    }

     .add-image{
        width:24px;
        background:white
    }
    /* .cancel-image{
        width:22px;
        background: white;
        transform: rotate(45deg);
    } */
    .back-image{
        width: 24px;
        /* border: 1px solid #000; */
        background:transparent;
    }
    .backbuttons{
        /* position: fixed;
        top: 15px;
        left: 55px;
        font-size: 28px;
        margin-right: 50px; */
        cursor: pointer;
        z-index: 1;

    }

   @media(min-width: 660px){
        /* .addbutton{
            right:10px !important;
        } */
        .actionbuttons{
            position: fixed;
            top: 20px;
            left: 50px !important;
            right: 50px !important;
            z-index: 1;
        }

         .hero-img{
            min-height: 20%;
            min-height: 20vh;
            background: lightgray;
        }
    }

    /*  @media(min-width: 1024px) and (max-width: 1024px){
        .addbutton{
            right: 35px !important;
        }
        .backbutton{
            left: 33px !important;
        }
    }
    @media(min-width: 768px) and (max-width: 768px){
        .addbutton{
            right: 28px !important;
        }
        .backbutton{
            left: 26px !important;
        }
    }
     @media(min-width: 320px) and (max-width: 320px){
        .addbutton{
            right: 21px !important;
        }
    } */
    .addbutton{
        /* position: fixed;
        top: -11px;
        right: 55px;
        font-size: 55px;
        margin-left: 50px; */
        cursor: pointer;
        z-index: 1;
    }
    .actionbuttons{
        position: fixed;
        top: 20px;
        left: 16px;
        right: 22px;
        z-index: 1;
    }
    .centered {
        position: absolute;
        top: 15%;
        left: 50%;
        font-weight: bold;
        font-size: 5rem;
        color:white;
        font-family: 'Barlow', sans-serif;
        transform: translate(-50%, -50%);
    }
    
    @media only screen and (max-width: 700px) {
        .centered {
            font-size: 1.5rem;
        }
    }

.product  {

    -webkit-animation: fadein 2s; /* Safari, Chrome and Opera > 12.1 */
       -moz-animation: fadein 2s; /* Firefox < 16 */
        -ms-animation: fadein 2s; /* Internet Explorer */
         -o-animation: fadein 2s; /* Opera < 12.1 */
            animation: fadein 2s;
}

@keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Internet Explorer */
@-ms-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Opera < 12.1 */
@-o-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

</style>